// extracted by mini-css-extract-plugin
export default {"DiscoverContainer":"xTen5ZRIBs","HeaderTabsActive":"dx2HHiLjvp","ContentWrapper":"KNVITdlL4Z","HeaderTabs":"NVLLn_i5Nd","ContentContainer":"auqzzxAMFP","ContentBlurb":"K06CGPDrQ2"};